import * as React from 'react';
import {Select, type SelectMultiProps} from '../select';
import type {SelectValue} from '../_select-internals';
import type {ReactNode} from 'react';

type MultiSelectProps<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
> = Omit<SelectMultiProps<T, V, L>, 'isMulti'>;

const MultiSelect = React.forwardRef(function MultiSelect<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
>(props: MultiSelectProps<T, V, L>, ref: React.Ref<HTMLDivElement>) {
  return <Select ref={ref} {...(props as SelectMultiProps<T, V, L>)} isMulti />;
}) as <T = unknown, V extends SelectValue = string, L extends ReactNode = string>(
  props: MultiSelectProps<T, V, L> & {ref?: React.Ref<HTMLDivElement>},
) => React.ReactElement;

export {MultiSelect};
export type {MultiSelectProps};
